<div class="m-multi-row" [formGroup]="tikNum">
	<div class="form-row row">
		<button type="button"  *ngIf="displayX" class="close" aria-label="Close" (click)="removed.emit(index)">
			<span aria-hidden="true">&times;</span>
		</button>
		<div class="form-group col-12">
			<div class="text-right m-title">
				{{ ph[0] | translate }} {{index + 1}}
			</div>
        <input type="tel" placeholder="{{ph[0]| translate}} {{index + 1}}" formControlName="internalTikNum" 
        [attr.id]="'internalTikNum'+index" class="form-control m-sm-form-control" [attr.aria-label]="titles[0]|translate"/>
				<div class="m-error" *ngIf="tikNum.get('internalTikNum').hasError('required') && displayErrors">
					{{ 'COMMON.FIELD_REQUIRED' | translate }}
				</div>
				<div class="m-error" *ngIf="tikNum.get('internalTikNum').hasError('pattern') && displayErrors">
					{{ 'CYCLE_DETAILS.Q9-2.NOTVALID' | translate }}
				</div>
    </div>		
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/add-tik-num/add-tik-num.component.html